import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { motion, Variants } from 'framer-motion';
import { useMediaPredicate } from 'react-media-hook';
// import UAParser from 'ua-parser-js';

import FamilyMembers from 'components/FamilyMembers';
import { HIDE_NAV_PATHS } from 'lib/constants';
import Line from 'assets/line.png';
import { cn } from 'lib/utils';
import useDashboard from 'hooks/useDashboard';
import useNavInfo from 'hooks/useNavInfo';
import { PATH_ROUTES } from 'routes/path';

export default function Navbar({ isExpanded }: { isExpanded: boolean }) {
  const { pathname } = useLocation();
  const { navInfo } = useNavInfo();

  const isMediaTab = useMediaPredicate('(max-width: 1023px)');
  const isMediaMobile = useMediaPredicate('(max-width: 640px)');
  // const [isMobile] = useState(
  //   UAParser(navigator.userAgent).device.type === 'mobile'
  // );

  const { isDashboard } = useDashboard();

  const isGenerating = useCallback(
    () =>
      [
        PATH_ROUTES.GENERATE_AI_REPORT,
        PATH_ROUTES.GENERATE_LAB_REPORT,
        PATH_ROUTES.START_FACE_SCAN,
      ].includes(pathname),
    [pathname]
  );

  const variants: Variants = {
    closed: {
      left: isMediaTab ? 0 : '5rem',
      width: isMediaTab ? '100%' : 'calc(100vw - 5rem)',
      transition: { type: 'spring', damping: 15, duration: 0.1 },
    },
    open: {
      left: isMediaTab ? 0 : '16.5rem',
      width: isMediaTab ? '100%' : 'calc(100vw - 16.5rem)',
      transition: { type: 'spring', damping: 15, duration: 0.3 },
    },
  };

  const hideNavbar =
    HIDE_NAV_PATHS.includes(pathname) ||
    isDashboard ||
    ([
      PATH_ROUTES.START_FACE_SCAN,
      PATH_ROUTES.FACE_SCAN_RESULT + '/',
      PATH_ROUTES.FACE_SCAN_RESULT,
      PATH_ROUTES.SEND_FEEDBACK + '/',
      PATH_ROUTES.SEND_FEEDBACK,
    ].includes(pathname) &&
      isMediaMobile);

  return (
    <motion.div
      className={cn(
        'header relative lg:absolute top-0 z-30 grid w-full h-24 bg-white',
        hideNavbar ? 'hidden' : 'block'
      )}
      variants={variants}
      animate={isExpanded ? 'open' : 'closed'}
      initial='closed'
    >
      <div className='absolute max-w-sm -translate-y-1/2 top-1/2 left-4 lg:left-8'>
        <h1 className='text-xl font-semibold'>{navInfo.title}</h1>
        <p className='pr-2 font-medium leading-tight'>{navInfo.desc}</p>
      </div>
      <div className='grid h-full grid-cols-12'>
        <div className='col-span-4' />
        <div className='h-full col-span-8 bg-nav-gradient'>
          {isGenerating() ? null : (
            <div className='hidden h-full lg:block'>
              <div className='relative z-50 flex items-center justify-end h-full p-4 pr-8'>
                <FamilyMembers />
              </div>
            </div>
          )}
        </div>
      </div>
      <div className='absolute right-0 hidden h-16 lg:block top-4'>
        <img src={Line} alt='line' className='object-cover h-full w-fit' />
      </div>
    </motion.div>
  );
}
